import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";

const Login = () => {
  const { enqueueSnackbar } = useSnackbar();

  const history = useHistory();
  const [isLoading, setLoaded] = useState(false);
  const [userData, setData] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });

  function handleChange(e) {
    const { name, value } = e.target;

    setData((preVal) => {
      return { ...preVal, [name]: value };
    });
  }
  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */

  const login = async (formData) => {
    if (validateInput(userData)) {
      try {
        setLoaded(true);
        let res = await axios.post(`${config.endpoint}/auth/login`, {
          username: userData.username,
          password: userData.password,
        });
        console.log(res);
        let token = res.data.token;
        let username = res.data.username;
        let balance = res.data.balance;
        persistLogin(token, username, balance);

        setLoaded(false);
        enqueueSnackbar("Logged in successfully", {
          variant: "success",
        });
        history.push("/");
      } catch (error) {
        setLoaded(false);
        console.log(error.response.data.message);
        let errorMsg = error.response.data.message;
        enqueueSnackbar(errorMsg, {
          variant: "error",
        });
      }
      setData({
        username: "",
        password: "",
        confirmPassword: "",
      });
    }
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */

  const validateInput = (data) => {
    if (!data.username || data.username.length === 0) {
      enqueueSnackbar("Username is a required field", { variant: `warning` });
      return false;
    } else if (data.username.length > 0 && data.username.length < 6) {
      enqueueSnackbar("Username must be at least 6 characters", {
        variant: `warning`,
      });
      return false;
    } else if (!data.password || data.password.length === 0) {
      enqueueSnackbar("Password is a required field", { variant: `warning` });
      return false;
    } else if (data.password.length > 0 && data.password.length < 6) {
      enqueueSnackbar("Password must be at least 6 characters", {
        variant: `warning`,
      });
      return false;
    }
    return true;
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */

  const persistLogin = (token, username, balance) => {
    localStorage.setItem("token", token);
    localStorage.setItem("username", username);
    localStorage.setItem("balance", balance);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={history} />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Login</h2>
          <TextField
            onChange={handleChange}
            value={userData.username}
            label="username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
          />
          <TextField
            onChange={handleChange}
            value={userData.password}
            label="password"
            variant="outlined"
            title="password"
            name="password"
            type="password"
            placeholder="Enter Password"
            fullWidth
          />
          <Button onClick={login} variant="contained">
            {isLoading ? <CircularProgress /> : "LOGIN TO QKART"}
          </Button>
          {/* className="button"  */}
          <p className="secondary-action">
            Don't have a account?
            {/* <a className="link" href="#">
              Register now
            </a> */}
            <Link to="/register">Register now</Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
